import { create } from "zustand";
import { Editor } from "@tiptap/react";

type WindowShowing =
    | {
          type: "Tab";
          tabID: string;
          width: number;
          offset: { x: number; y: number };
      }
    | {
          type: "Link";
      } |
      {
          type: "ContextMenu";
          children: React.ReactNode;
      }
    | undefined;

export type AbsoluteWindowStore = {
    position: { x: number; y: number };
    windowShowing: WindowShowing;
    setPosition: (x: number, y: number) => void;
    setWindowShowing: (data: WindowShowing) => void;
    showTextMenu: (editor: Editor | null) => void;
};

const useAbsoluteWindowStore = create<AbsoluteWindowStore>((set, get) => ({
    position: { x: 330, y: 330 },
    windowShowing: undefined,
    setPosition: (x: number, y: number) => set({ position: { x, y } }),
    setWindowShowing: (data) => set({ windowShowing: data }),
    showTextMenu: (editor: Editor | null) => {
        const state = editor?.state;
        const view = editor?.view;
        if (state?.selection) {
            const { from, to } = state.selection;

            const start = view?.coordsAtPos(from);
            const end = view?.coordsAtPos(to - 1); // This needs -1 otherwise it goes to next line

            if (!start || !end) return;

            get().setWindowShowing({
                type: "Link",
            });

            const width = (start.left + end.right) / 2;

            console.log(start.left, end.right);
            

            get().setPosition(width, start!.top - 40);
        }
    },
}));

export default useAbsoluteWindowStore;
